import * as angular from 'angular';

function filterFunction() {
    function filterFilter(params: any) {
        params = (params === undefined || params === null) ? '' : params;
        return params.toString().toLowerCase().replace(/\b([a-z])/g, (ch: string) => {
            return ch.toUpperCase();
        });
    }
}
angular.module('naut')
    .filter('titlecase', filterFunction);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/common/filters/titleCase.filter.ts